export const GET_CONFIGURATION = 'GET_CONFIGURATION';
export const GET_CONFIGURATION_STARTED = `${GET_CONFIGURATION}_STARTED`;
export const GET_CONFIGURATION_SUCCEED = `${GET_CONFIGURATION}_SUCCEED`;
export const GET_CONFIGURATION_FAILED = `${GET_CONFIGURATION}_FAILED`;
